import type { DragEndEvent } from '@dnd-kit/core';
import { closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import type { TalkingPointDto } from '../../../api/generated/client';
import { AdminTopicSortableItem } from './AdminTopicSortableItem';

interface IProps {
    items: TalkingPointDto[];
    onChange: (items: TalkingPointDto[]) => void;
}

export const AdminTopicSortList: FunctionComponent<IProps> = ({ items, onChange }) => {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    );

    const onDragEnd = (result: DragEndEvent) => {
        const { active, over } = result;

        // dropped outside the list
        if (!over) return;

        if (active.id !== over.id) {
            const oldIndex = items.map((item) => item.id).indexOf(Number(active.id));
            const newIndex = items.map((item) => item.id).indexOf(Number(over.id));

            onChange(arrayMove(items, oldIndex, newIndex));
        }
    };

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
            <SortableContext items={items} strategy={verticalListSortingStrategy}>
                <ZfStack
                    direction="column"
                    spacing="small"
                    style={{ background: 'var(--bg-color-default-emphasis)', padding: 'var(--padding-horizontal-sm)', marginTop: 'var(--padding-top-sm)' }}
                >
                    {items.map((item) => (
                        <AdminTopicSortableItem key={item.id} point={item} />
                    ))}
                </ZfStack>
            </SortableContext>
        </DndContext>
    );
};
